import { Routes, Route } from 'react-router';
import { lazy, Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import { RequireAuth } from './components/layout/RequireAuth';
import { AppLayout } from './components/layout/AppLayout';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { ContentLoading } from './components/ui/ContentLoading';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const TimeTracking = lazy(() => import('./pages/TimeTracking'));
const Projects = lazy(() => import('./pages/Projects'));
const Approvals = lazy(() => import('./pages/Approvals'));
const Users = lazy(() => import('./pages/Users'));
const Invoices = lazy(() => import('./pages/Invoices'));
const Reports = lazy(() => import('./pages/Reports'));
const Settings = lazy(() => import('./pages/Settings'));
const XeroCallback = lazy(() => import('./pages/XeroCallback'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function PageLoader() {
  return <ContentLoading />;
}

export function App() {
  return (
    <ErrorBoundary>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { fontSize: '14px' },
        }}
      />
      <Routes>
        <Route element={<RequireAuth />}>
          <Route element={<AppLayout />}>
            <Route index element={<Suspense fallback={<PageLoader />}><Dashboard /></Suspense>} />
            <Route path="time-tracking" element={<Suspense fallback={<PageLoader />}><TimeTracking /></Suspense>} />
            <Route path="projects" element={<Suspense fallback={<PageLoader />}><Projects /></Suspense>} />
            <Route path="approvals" element={<Suspense fallback={<PageLoader />}><Approvals /></Suspense>} />
            <Route path="users" element={<Suspense fallback={<PageLoader />}><Users /></Suspense>} />
            <Route path="invoices" element={<Suspense fallback={<PageLoader />}><Invoices /></Suspense>} />
            <Route path="reports" element={<Suspense fallback={<PageLoader />}><Reports /></Suspense>} />
            <Route path="settings" element={<Suspense fallback={<PageLoader />}><Settings /></Suspense>} />
            <Route path="settings/integrations/xero/callback" element={<Suspense fallback={<PageLoader />}><XeroCallback /></Suspense>} />
            <Route path="*" element={<Suspense fallback={<PageLoader />}><NotFoundPage /></Suspense>} />
          </Route>
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
